import React, { createContext, useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useStore } from './StoreContext';

type ComandaMode = 'simples' | 'cartao' | null;

interface IComandaSessionData {
    comandaMode: ComandaMode;
    mesaNumber: string | null;
    cartaoCode: string | null;
    comandaId: string | null;
    setComandaId: (id: string | null) => void;
}

const ComandaSessionContext = createContext<IComandaSessionData>({
    comandaMode: null,
    mesaNumber: null,
    cartaoCode: null,
    comandaId: null,
    setComandaId: () => {},
});

export const useComandaSession = () => useContext(ComandaSessionContext);

export const ComandaSessionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [searchParams] = useSearchParams();
    const { store } = useStore();
    const [comandaId, setComandaId] = useState<string | null>(() => sessionStorage.getItem('comanda_simples_id'));

    const mesaParam = searchParams.get('mesa');
    const cartaoParam = searchParams.get('cartao');

    let comandaMode: ComandaMode = null;
    let mesaNumber: string | null = null;
    let cartaoCode: string | null = null;

    if (store && !store.clienteNaoFazPedidos) {
        if (mesaParam && store.comandaSimples) {
            comandaMode = 'simples';
            mesaNumber = mesaParam;
        } else if (cartaoParam && store.comandaCartao) {
            comandaMode = 'cartao';
            cartaoCode = cartaoParam;
        }
    }

    return (
        <ComandaSessionContext.Provider value={{ comandaMode, mesaNumber, cartaoCode, comandaId, setComandaId }}>
            {children}
        </ComandaSessionContext.Provider>
    );
};
